import { ApiError, ApiResult } from '@models/api';
import { UseQueryOptions, useQuery } from '@hooks/react-query';

import { ProfileResponse } from '../models/queries/types';

function useRGetProfile(
  options: UseQueryOptions<ApiResult<ProfileResponse>, ApiError> = {},
) {
  return useQuery<ApiResult<ProfileResponse>, ApiError>({
    queryKey: ['application/status'],
    ...options,
  });
}

export default useRGetProfile;
